<template>
    <div>
        <!-- for redeem standard modal -->
        <HorizontalConfirm
            ref="horizontal"
            :modalId="`${modalId}_horizontal`"
            :lblConfirm="lblConfirm"
            :showImage="showImage"
            :showIconClose="showIconClose"
            @clickConfirm="clickConfirm"
            @clickCancel="clickCancel"
            v-if="type == 'horizontal'" />
        <!-- for my self and transfer to friend modal -->
        <VerticalConfirm
            ref="vertical"
            :modalId="`${modalId}_vertical`"
            :lblConfirm="lblConfirm"
            :showImage="showImage"
            :showIconClose="showIconClose"
            @clickConfirm="clickConfirm"
            @clickCancel="clickCancel"
            @clickSendToFriend="clickSendToFriend"
            v-if="type == 'vertical'" />
        <AmbassadorConfirm
            ref="ambassador"
            :modalId="`${modalId}_ambassador`"
            :lblConfirm="lblConfirm"
            @clickConfirm="clickConfirm"
            @clickCancel="clickCancel"
            v-if="type == 'ambassador'" />
    </div>
</template>
<script>
//helper
import Util from "@/helper/Utility.js";
import LocaleMixin from "@/mixin/LocaleMixin.js";
//component
import AmbassadorConfirm from './AmbassadorConfirm.vue';
import HorizontalConfirm from './HorizontalConfirm.vue';
import VerticalConfirm from './VerticalConfirm.vue';

export default {
    name: 'ConfirmRedeemModal',
    mixins: [LocaleMixin],
    components: {
        AmbassadorConfirm,
        HorizontalConfirm,
        VerticalConfirm
    },
    props: {
        controller: Object,
        modalId: String,
    },
    data: function () {
        return {
            lblConfirm: null,
            showImage: false,
            showIconClose: false,

            campaign: {},
            campaignGroup: '',
            isAmbassadorCat: false,
            tag: '',
            type: '',//horizontal, vertical
            isTel: false,

            busModal: null,
        };
    },
    created: function () {
        this.busModal = this.controller.busModal;
    },
    mounted: function () {
        this.busModal.$on('show', this.show);
        this.busModal.$on('hide', this.hide);
    },
    methods: {
        //Event
        clickConfirm: function () {
            this.hide();
            this.controller.cbConfirm.sendCallback({tag: this.tag});
        },
        clickCancel: function () {
            this.hide();
            this.controller.cbCancel.sendCallback({tag: this.tag});
        },
        //custom event
        clickSendToFriend: function () {
            this.hide();
            this.controller.cbSendToFriend.sendCallback({tag: this.tag});
        },
        //initial
        initialModal: function () {
            console.log('initialModal', this.campaignGroup);
            switch(this.campaignGroup) {
                // group 1,2,3 - for my self and transfer to friend modal
                case '1':
                    if (!this.campaign.caption) {
                        this.type = 'vertical';
                        this.showImage = true;
                        this.showIconClose = true;
                        this.lblConfirm = {...this.lbl.confirm_redeem.group[this.campaignGroup]};
                    } else {
                        var captions = this.campaign.caption.split('|');
                        var telCaption = captions.filter(caption => {
                            return (caption.indexOf('tel.') >= 0);
                        });

                        //ISOS MEDIX
                        if (telCaption.length > 0) {
                            this.isTel = true;
                            this.type = 'horizontal';
                            this.showIconClose = true;
                            this.lblConfirm = {...this.lbl.confirm_redeem.group[this.campaignGroup]};
                        } else {
                            this.type = 'vertical';
                            this.showIconClose = true;
                            this.lblConfirm = {...this.lbl.confirm_redeem.group[this.campaignGroup]};
                        }
                    }
                    break
                case '2':
                case '3':
                    this.type = 'vertical';
                    this.showImage = true;
                    this.showIconClose = true;
                    this.lblConfirm = {...this.lbl.confirm_redeem.group[this.campaignGroup]};
                    break;
                case '4':
                    this.type = 'horizontal';
                    this.showImage = true;
                    this.lblConfirm = {...this.lbl.confirm_redeem.group[this.campaignGroup]};

                    var header = Util.stringFormat(this.lblConfirm.headline, this.campaign.categoryName);
                    this.lblConfirm.headline = header;
                    break;
                // group 5,6,7,9 - for redeem standard modal
                case '5':
                case '6':
                case '9':
                    this.type = 'horizontal';
                    this.showImage = true;
                    this.lblConfirm = {...this.lbl.confirm_redeem.group[this.campaignGroup]};
                    if (this.campaign.minutesValidAfterUsed) {
                        var header56 = this.checkMinutesValidAfterUsed();
                        this.lblConfirm.message = header56;
                    }
                    break;
                case '7':
                    this.type = 'horizontal';
                    this.showImage = true;
                    this.lblConfirm = {...this.lbl.confirm_redeem.group['default']};
                    if (this.campaign.minutesValidAfterUsed) {
                        var header7 = this.checkMinutesValidAfterUsed();
                        this.lblConfirm.message = header7;
                    }
                    break;
                case '8':
                    this.type = 'horizontal';
                    this.showImage = true;
                    this.lblConfirm = {...this.lbl.confirm_redeem.group[this.campaignGroup]};

                    var header8 = Util.stringFormat(this.lblConfirm.headline, this.campaign.categoryName);
                    this.lblConfirm.headline = header8;
                    break;
                case 'draw':
                    this.type = 'horizontal';
                    this.showImage = true;
                    this.lblConfirm = {...this.lbl.confirm_redeem.group[this.campaignGroup]};
                    break;
                default:
                    this.type = 'horizontal';
                    this.showImage = true;
                    this.lblConfirm = {...this.lbl.confirm_redeem.group[this.campaignGroup]};
                    if (this.campaign.minutesValidAfterUsed) {
                        var headerNormal = this.checkMinutesValidAfterUsed();
                        this.lblConfirm.message = headerNormal;
                    }
                    break
            }

            this.$nextTick(() => {
                // this.$refs[this.type].show();
                if (this.$refs[this.type] && this.$refs[this.type].show) {
                    this.$refs[this.type].show();
                }
            });
        },
        checkMinutesValidAfterUsed: function () {
            const minutes = this.campaign.minutesValidAfterUsed;
            let result = '';
            const totalHours = Math.floor(minutes / 60);
            const totalDays = Math.floor(totalHours / 24);
            const isEnglish = this.localeCode === 1033;

            if (totalDays > 0) {
                var dayLabel = this.lbl.date.days;
                if (isEnglish && totalDays > 1) {
                    dayLabel += 's';
                }
                result += `${totalDays} ${dayLabel} `;
            }

            const remainingHours = totalHours % 24;
            if (remainingHours > 0) {
                var hourLabel = this.lbl.date.hours;
                if (isEnglish && remainingHours > 1) {
                    hourLabel += 's';
                }
                result += `${remainingHours} ${hourLabel} `;
            }

            const remainingMinutes = minutes % 60;
            if (remainingMinutes > 0) {
                var minuteLabel = this.lbl.date.minutes;
                if (isEnglish && remainingMinutes > 1) {
                    minuteLabel += 's';
                }
                result += `${remainingMinutes} ${minuteLabel}`;
            }

            return Util.stringFormat(this.lblConfirm.headline_timer, result);
        },
        //modal
        show: function (config) {
            this.campaign = config.campaign;
            this.campaignGroup = config.campaignGroup;
            this.isAmbassadorCat = config.isAmbassadorCat;
            this.tag = config.tag;
            this.isTel = false;

            this.initialModal();
        },
        hide: function () {
            this.$refs[this.type].hide();
        }
    }
}
</script>
